import {useState} from "react";
import StatusGrid from "./StatusGrid";
import StatusLegend from "./StatusLegend";
import StatusProgress from "./StatusProgress";
import DisconnectedBanner from "../../displays/components/DisconnectedBanner";
import  './InspectionStatus.css';
import {InspectionUpdate} from "../../javaTypes";
import {usePersistentWebsocket} from "../../utils";
import { t } from "../../i18n";

/**
 * @param eventCode The event code
 * @param projector true if this is a projector version
 * @param columns The number of columns to group the teams into
 */
export default function InspectionStatus({eventCode, eventName, projector, columns} : {
    eventCode: string,
    eventName: string,
    projector: boolean,
    columns: number
}) {
    const [inspectionData, setInspectionData] = useState<InspectionUpdate>();
    const { isConnected, send } = usePersistentWebsocket<InspectionUpdate>(`/stream/inspection/?code=${eventCode}`, (data) => {
        setInspectionData(data);
    });

    return <div>
        {projector ? <>
              <h2 className="text-center">{eventName}</h2>
              <h4 className="text-center">{t`Inspection Status`}</h4>
          </> :
          <div className="d-flex">
              <div style={{float: "left"}}>
                  <a href={`/event/${eventCode}/`}>
                      &lt;&lt; {t`To Event Home`}
                  </a>
              </div>
              <div className="flex-fill">
                  <h1 className="text-center">{eventName}</h1>
                  <h4 className="text-center">{t`Inspection Status`}</h4>
              </div>
              <div style={{float: "right"}}>
                  <b>{t`Projector Friendly:`}</b><br />
                  <a href="proj/1/">{t`1 column`}</a><br />
                  <a href="proj/2/">{t`2 columns`}</a><br />
                  <a href="proj/3/">{t`3 columns`}</a><br />
              </div>
          </div>}

        {isConnected ? null : <DisconnectedBanner />}
        {!projector && inspectionData ? <StatusProgress statusList={inspectionData.statuses}
                                                        statusData={(inspectionData.teams ?? []).map(x => Object.values(x.statuses)).flat()} /> : null}
        <StatusGrid inspectionData={inspectionData} columns={columns} projector={projector} />
        <StatusLegend inspectionData={inspectionData} projector={projector} />
        </div>
        }